import { styled } from '@mui/material';
import { SxProps } from '@mui/system';

export const fileUploadDialogStyles: SxProps = {
  borderRadius: '0.5rem',
  padding: 2,
};

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
